<div class="{uiClasses} segments">
  {>slot}
</div>
